import { colors } from '@atlaskit/theme'
import { ZeraLogo } from '@zera-admin/logo'
import Spinner from '@zera-admin/spinner'

import { Flex, FlexContent, FlexFooter } from './Empty.styled'
import { EmptyLayoutProps } from './types'

const EmptyLayout: React.FunctionComponent<EmptyLayoutProps> = ({
  children,
  isReady = false,
}) => {
  if (isReady) {
    return (
      <Flex>
        <FlexContent>{children}</FlexContent>
        <FlexFooter>
          <ZeraLogo iconColor={colors.N400} size="small" />
        </FlexFooter>
      </Flex>
    )
  }
  return (
    <Flex>
      <Spinner />
    </Flex>
  )
}

export default EmptyLayout
